<div class="manageAccountWrapper">

    <div class="contactSales">
        <a routerLink="/contact">Contact Sales</a>
    </div>

    <div class="part">
        <div class="partTop">
            <div class="label">
                Personal Info
            </div>
            <div class="edit" (click)="editPersonal()">
                Edit
            </div>
        </div>
        <div class="partInfo" *ngIf="!partInfoOpen">
            <div class="name">
                {{authService.profile?.firstName}} {{authService.profile?.lastName}}
            </div>
            <div class="phone">
                {{authService.profile?.phone}}
            </div>
            <div class="email">
                {{authService.profile?.email}}
            </div>

            <div class="deleteSection">
                <div class="deleteInfo">
                    If you want to shut down this account. please make sure your decision is<br>final before proceeding. All your stored data will be erased.
                </div>
                <div class="deleteButton" (click)="deleteProfile(authService.profile)">
                            Delete Account
                        </div>
            </div>
        </div>

        <div class="partInfoEdit" *ngIf="partInfoOpen">
            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                <div formGroupName="user" class="userInput">

                    <div class="split">

                        <mat-form-field>
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName">
                            <mat-error *ngIf="registerForm.get('user.firstName')?.hasError('required')">First Name is
                                required</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName">
                            <mat-error *ngIf="registerForm.get('user.lastName')?.hasError('required')">Last Name is
                                required</mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="phone" placeholder="(123) 456-7890" appPhoneMask>
                        <mat-error *ngIf="registerForm.get('user.phone')?.hasError('required')">Phone is
                            required</mat-error>
                        <mat-error *ngIf="registerForm.get('user.phone')?.hasError('pattern')">Enter a valid phone
                            number (e.g., (123) 456-7890)</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" type="email">
                        <mat-error *ngIf="registerForm.get('user.email')?.hasError('required')">Email is
                            required</mat-error>
                        <mat-error *ngIf="registerForm.get('user.email')?.hasError('email')">Enter a valid
                            email</mat-error>
                    </mat-form-field>

                    <div class="buttons">
                        <div class="save">
                            <div class="label" (click)="savePersonal()">SAVE</div>
                        </div>

                        <div class="cancel" (click)="closePersonal()">
                            <div class="label">CANCEL</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="part">
        <div class="partTop">
            <div class="label">
                Password
            </div>
            <div class="edit" (click)="changePassword()">
                Change Password
            </div>
        </div>
        <div class="partInfo" *ngIf="!partPawwordOpem">
            <div class="name">
                Password: ●●●●●●●●
            </div>

        </div>

        <div class="partInfoEdit" *ngIf="partPawwordOpem">
            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                <div class="userInput">

                    <div class="passInput">

                        <mat-form-field>
                            <mat-label>Password</mat-label>
                            <input matInput formControlName="password"
                                [type]="!isPasswordVisible ? 'password' : 'text' " [(ngModel)]="password"
                                (ngModelChange)="onPasswordChange($event)">
                            <mat-error *ngIf="registerForm.get('password')?.hasError('required')">Password
                                required</mat-error>
                            <div class="showPassword" (click)="passwordVisibleToggle()">
                                <mat-icon *ngIf="isPasswordVisible">visibility</mat-icon>
                                <mat-icon *ngIf="!isPasswordVisible">visibility_off</mat-icon>
                            </div>
                        </mat-form-field>

                        <div class="strength-meter">
                            <div class="strength-bar" [ngClass]="passwordStrength().strength"
                                [style.width.%]="passwordStrength().score * 25"></div>
                        </div>
                        <p>Strength: {{ passwordStrength().strength }}</p>
                        <ul>
                            @for (feedback of passwordStrength().feedback; track feedback) {
                            <li>{{ feedback }}</li>
                            }
                        </ul>
                        <p *ngIf="passwordStrength().isValid" class="valid">Password is valid!</p>

                        <mat-form-field>
                            <mat-label>Retype Password</mat-label>
                            <input [type]="!isPasswordVisible2 ? 'password' : 'text' " matInput
                                formControlName="confirmPassword" (ngModelChange)="onRePasswordChange($event)">
                            <mat-error *ngIf="registerForm.get('confirmPassword')?.hasError('required')">Retype password
                                required</mat-error>
                            <mat-error *ngIf="registerForm.get('confirmPassword')?.hasError('required')">Retype password
                                required</mat-error>
                            <div class="showPassword" (click)="passwordVisibleToggle2()">
                                <mat-icon *ngIf="isPasswordVisible2">visibility</mat-icon>
                                <mat-icon *ngIf="!isPasswordVisible2">visibility_off</mat-icon>
                            </div>
                        </mat-form-field>
                    </div>

                    <!-- <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="phone" placeholder="(123) 456-7890" appPhoneMask>
                        <mat-error *ngIf="registerForm.get('user.phone')?.hasError('required')">Phone is
                            required</mat-error>
                        <mat-error *ngIf="registerForm.get('user.phone')?.hasError('pattern')">Enter a valid phone
                            number (e.g., (123) 456-7890)</mat-error>
                    </mat-form-field> -->



                    <div class="buttons">
                        <div class="save" [ngClass]="{disabled: isNextButtonDisabled}">
                            <div class="label" (click)="savePassword()">SAVE</div>
                        </div>

                        <div class="cancel" (click)="closePassword()">
                            <div class="label">CANCEL</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="part">
        <div class="partTop">
            <div class="label">
                Theaters
            </div>
            <div class="edit_add">
                <div class="add" (click)="addNewTheater()">
                    Add Theater
                </div>
                <!-- <div class="edit" (click)="editTheaters()">
                    Edit
                </div> -->
            </div>
        </div>
        <div class="partInfo" *ngIf="!theatersOpen">




            <div class="theaterItem" *ngFor="let theater of authService.profile?.theaters; let i = index;">
                <div class="frontend" *ngIf="i != editIndex">

                    <div class="splitTheater">
                        <div class="name">
                            {{theater?.name}}
                        </div>
                        <div class="editBtn">
                            <a (click)="editTheater(i)">Edit</a>
                        </div>
                    </div>

                    <div class="address">
                        {{theater.adress}} <br>
                        {{theater.city}}, {{theater.state}} {{theater.zip}}
                    </div>

                    <div class="address">
                        {{theater.phone}}
                    </div>

                    <div class="address">
                        Preferred format: {{theater.preferredFormat}}
                    </div>

                    <!-- <div class="address">
                        Admission Charges: {{theater.admissionCharges ? 'Yes' : 'No' }}
                    </div> -->
                </div>

                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" *ngIf="i == editIndex">
                    <div formArrayName="theaters">
                        <div *ngFor="let theaterCont of theaters.controls; let j=index" [formGroupName]="j"
                            class="userInput">
                            <div class="edit" *ngIf="j == editIndex">
                                <!-- <div class="edit"> -->

                                <h4>&nbsp;</h4>
                                <mat-form-field>
                                    <mat-label>Theater Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="theaters.controls[j].get('name')?.hasError('required')">Name is
                                        required</mat-error>
                                </mat-form-field>

                                <div class="split">


                                    <mat-form-field>
                                        <mat-label>Address</mat-label>
                                        <input matInput formControlName="adress">
                                        <mat-error
                                            *ngIf="theaters.controls[j].get('adress')?.hasError('required')">Address
                                            is required</mat-error>
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>City</mat-label>
                                        <input matInput formControlName="city">
                                        <mat-error *ngIf="theaters.controls[j].get('city')?.hasError('required')">City
                                            is
                                            required</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="split">




                                    <mat-form-field class="theater-dropdown half-width">
                                        <mat-label>State</mat-label>
                                        <mat-select formControlName="state" placeholder="Select a state"
                                            (selectionChange)="onStateSelected()">
                                            <mat-option *ngFor="let state of states" [value]="state.code">
                                                {{ state.code }} - {{ state.name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="theaters.controls[j].get('state')?.hasError('required')">State
                                            is
                                            required</mat-error>
                                    </mat-form-field>








                                    <!-- <mat-form-field>
                                        <mat-label>State</mat-label>
                                        <input matInput formControlName="state">
                                        <mat-error *ngIf="theaters.controls[j].get('state')?.hasError('required')">State
                                            is
                                            required</mat-error>
                                    </mat-form-field> -->
                                    <mat-form-field>
                                        <mat-label>ZIP</mat-label>
                                        <input matInput formControlName="zip" placeholder="12345">
                                        <mat-error *ngIf="theaters.controls[j].get('zip')?.hasError('required')">ZIP is
                                            required</mat-error>
                                        <mat-error *ngIf="theaters.controls[j].get('zip')?.hasError('pattern')">Enter a
                                            valid 5-digit ZIP code</mat-error>
                                    </mat-form-field>
                                </div>

                                <mat-form-field>
                                    <mat-label>Phone</mat-label>
                                    <input matInput formControlName="phone" placeholder="(123) 456-7890" appPhoneMask>
                                    <mat-error *ngIf="theaters.controls[j].get('phone')?.hasError('required')">Phone is
                                        required</mat-error>
                                    <mat-error *ngIf="theaters.controls[j].get('phone')?.hasError('pattern')">Enter a
                                        valid
                                        phone
                                        number (e.g., (123) 456-7890)</mat-error>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Preferred Format</mat-label>
                                    <mat-select formControlName="preferredFormat">
                                        <mat-option value="Rights only —Self Supplied">Rights only —Self
                                            Supplied</mat-option>
                                        <mat-option value="DCP">DCP</mat-option>
                                        <mat-option value="35mm">35mm</mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="theaters.controls[j].get('preferredFormat')?.hasError('required')">Preferred
                                        Format is required</mat-error>
                                </mat-form-field>
                                <!-- <mat-checkbox formControlName="admissionCharges">Admission Charges</mat-checkbox> -->
                                <br>
                                <div class="buttonHolder">
                                    <button class="deleteButton" mat-button color="warn" (click)="removeTheater(j)"
                                        *ngIf="theaters.length > 0">
                                        <mat-icon>delete</mat-icon>
                                        Remove Theater</button>
                                </div>
                                <div class="buttons">
                                    <div class="save">
                                        <div class="label" (click)="saveTheater()">SAVE</div>
                                    </div>

                                    <div class="cancel" (click)="closeEditTheater()">
                                        <div class="label">CANCEL</div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- <div class="partInfoEdit" *ngIf="theatersOpen">
            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                <div formArrayName="theaters">

                    <div *ngFor="let theater of theaters.controls; let i=index" [formGroupName]="i" class="userInput">
                        <h4>Theater {{ i + 1 }}</h4>
                        <mat-form-field>
                            <mat-label>Theater Name</mat-label>
                            <input matInput formControlName="name">
                            <mat-error *ngIf="theaters.controls[i].get('name')?.hasError('required')">Name is
                                required</mat-error>
                        </mat-form-field>

                        <div class="split">


                            <mat-form-field>
                                <mat-label>Address</mat-label>
                                <input matInput formControlName="adress">
                                <mat-error *ngIf="theaters.controls[i].get('adress')?.hasError('required')">Address
                                    is required</mat-error>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>City</mat-label>
                                <input matInput formControlName="city">
                                <mat-error *ngIf="theaters.controls[i].get('city')?.hasError('required')">City is
                                    required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="split">


                            <mat-form-field>
                                <mat-label>State</mat-label>
                                <input matInput formControlName="state">
                                <mat-error *ngIf="theaters.controls[i].get('state')?.hasError('required')">State is
                                    required</mat-error>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>ZIP</mat-label>
                                <input matInput formControlName="zip" placeholder="12345">
                                <mat-error *ngIf="theaters.controls[i].get('zip')?.hasError('required')">ZIP is
                                    required</mat-error>
                                <mat-error *ngIf="theaters.controls[i].get('zip')?.hasError('pattern')">Enter a
                                    valid 5-digit ZIP code</mat-error>
                            </mat-form-field>
                        </div>

                        <mat-form-field>
                            <mat-label>Phone</mat-label>
                            <input matInput formControlName="phone" placeholder="(123) 456-7890" appPhoneMask>
                            <mat-error *ngIf="theaters.controls[i].get('phone')?.hasError('required')">Phone is
                                required</mat-error>
                            <mat-error *ngIf="theaters.controls[i].get('phone')?.hasError('pattern')">Enter a valid
                                phone
                                number (e.g., (123) 456-7890)</mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Preferred Format</mat-label>
                            <mat-select formControlName="preferredFormat">
                                <mat-option value="2D">2D</mat-option>
                                <mat-option value="3D">3D</mat-option>
                                <mat-option value="IMAX">IMAX</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="theaters.controls[i].get('preferredFormat')?.hasError('required')">Preferred
                                Format is required</mat-error>
                        </mat-form-field>
                        <mat-checkbox formControlName="admissionCharges">Admission Charges</mat-checkbox>
                        <br>
                        <button mat-button color="warn" (click)="removeTheater(i)" *ngIf="theaters.length > 0">Remove
                            Theater</button>
                    </div>

                </div>

                <div class="buttons">
                    <div class="save">
                        <div class="label" (click)="saveTheater()">SAVE</div>
                    </div>

                    <div class="cancel" (click)="closeTheaters()">
                        <div class="label">CANCEL</div>
                    </div>
                </div>
            </form>
        </div> -->




    <!-- <div class="part">
        <div class="partTop">
            <div class="label">
                Sales Contact
            </div>
            <div class="edit" (click)="editSales()">
                Edit
            </div>
        </div>
        <div class="partInfo" *ngIf="!partSalesOpen">
            <div class="name">
                {{authService.profile?.salesFirstName}} {{authService.profile?.salesLastName}}
            </div>
            <div class="email">
                {{authService.profile?.salesTitle}}
            </div>
            <div class="phone">
                {{authService.profile?.salesPhone}}
            </div>
            <div class="email">
                {{authService.profile?.salesEmail}}
            </div>

            <div class="logoutButton">
                <div class="buttons">
                    <div class="cancel" (click)="logout()">
                        <div class="label">Log out</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="partInfoEdit" *ngIf="partSalesOpen">
            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                <div formGroupName="sales" class="userInput">

                    <div class="split">

                        <mat-form-field>
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName">
                            <mat-error *ngIf="registerForm.get('sales.firstName')?.hasError('required')">First Name is
                                required</mat-error>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName">
                            <mat-error *ngIf="registerForm.get('sales.lastName')?.hasError('required')">Last Name is
                                required</mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field>
                        <mat-label>Title</mat-label>
                        <input matInput formControlName="title">
                        <mat-error *ngIf="registerForm.get('sales.title')?.hasError('required')">Title is
                            required</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="phone" placeholder="(123) 456-7890" appPhoneMask>
                        <mat-error *ngIf="registerForm.get('sales.phone')?.hasError('required')">Phone is
                            required</mat-error>
                        <mat-error *ngIf="registerForm.get('sales.phone')?.hasError('pattern')">Enter a valid phone
                            number (e.g., (123) 456-7890)</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" type="email">
                        <mat-error *ngIf="registerForm.get('sales.email')?.hasError('required')">Email is
                            required</mat-error>
                        <mat-error *ngIf="registerForm.get('sales.email')?.hasError('email')">Enter a valid
                            email</mat-error>
                    </mat-form-field>

                    <div class="buttons">
                        <div class="save">
                            <div class="label" (click)="saveSales()">SAVE</div>
                        </div>

                        <div class="cancel" (click)="closeSales()">
                            <div class="label">CANCEL</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div> -->
</div>